import React, {Component} from "react";
// La instancia directa y no `src/i18n.js`, como `DashboardCell`: importar ese módulo rompe las suites
// que mockean `react-i18next` sin el stub de `initReactI18next`.
import i18next from "i18next";
import {CAMPAIGN_STATUS_ACTIVE} from "../../../marketing";
import {BusinessUnitShowAdAccountsOrCampaignsTooltip} from "../BusinessUnitShowAdAccountsOrCampaignsTooltip";

export class CampaignNameCell extends Component {

    renderStatus() {
        if(this.props.status !== CAMPAIGN_STATUS_ACTIVE) {
            const label = i18next.isInitialized ? i18next.t('dashboard.campaign_not_active') : '[No activa]';
            return <span className="ml-2 mr-2  status_not_active">{label}</span>
        }
    }

    render() {
        return (
            <td>
                <div className="bu-cell ad_account_row">
                    <div className="bu-name-with-tooltip">
                        <div className="campaign-name" title={this.props.campaignName}>
                            {this.props.campaignName}{this.renderStatus()}
                        </div>
                    </div>
                    <div className="some-icons">
                        {this.renderToggleDetails()}
                    </div>
                </div>
            </td>
        );
    }

    renderToggleDetails() {
        // const tooltipMessage = !this.props.hasAdAccountsDataToShow ? "Hay una sola cuenta publicitaria configurada en el presupuesto." : null;

        if(!this.props.hasAdgroupsData)
            return;

        const tooltipMessage = null;

        // `isShowing` es el estado con el que el botón ARRANCA (después lo lleva él). Cerrar la línea
        // desmonta esta fila, pero `DashboardRow` recuerda qué campañas estaban abiertas: con un
        // `false` fijo, al reabrirla los grupos se veían con un (+) al lado, y cada clic lo dejaba
        // al revés.
        return <BusinessUnitShowAdAccountsOrCampaignsTooltip key="bu-show-ad-accounts-icon"
                                                             message={tooltipMessage}
                                                             onClick={() => this.props.onAdgroupsDataToggle(this.props.campaignId)}
            // enabled={this.props.hasAdAccountsDataToShow}
                                                             enabled={true}
                                                             isShowing={this.props.adgroupsShowing === true}
        />
    }


}
